"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inline = exports.Link = exports.TextLink = exports.Text = exports.TextWithLinks = void 0;
const native_1 = __importStar(require("styled-components/native"));
exports.TextWithLinks = native_1.default.View `
  flex-direction: row;
  flex-wrap: wrap;
  /* padding: 0 32px 0 20px; */
`;
exports.Text = native_1.default.Text `
  ${({ theme }) => native_1.css `
      font-size: ${theme.card['text-medium'].size};
      line-height: ${theme.card['text-medium'].lineHeight};
    `}
`;
exports.TextLink = native_1.default(exports.Text) `
  color: ${(p) => p.theme.color.primary};
  text-decoration: underline;
  text-decoration-color: ${(p) => p.theme.text.color.tertiary};
`;
exports.Link = native_1.default.TouchableOpacity ``;
exports.Inline = native_1.default.View `
  flex-direction: row;
`;
